(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('shoppingCart', shoppingCart);

    /* @ngInject */
    function shoppingCart() {
        var directive = {
            bindToController: true,
            templateUrl: 'shopping-cart.tpl',
            controller: shoppingCartController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '='
            }
        };

        return directive;

        function link(scope, element, attrs) {
        }
    }

    /* @ngInject */
    function shoppingCartController () {
    }

})();